var _effectorFileName = "/src/page-content/payment/components/combobox-teachers/combobox-teachers.tsx";
import * as React from 'react';
import Image from 'next/image';
import { Teacher } from '@/pages/api/teachers/types';
import { CaretSortIcon } from '@radix-ui/react-icons';
import CheckMarkIcon from '@/shared/components/icons/checkmark-icon';
import { Button } from '@/shared/components/ui/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/shared/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/components/ui/popover';
import { cn } from '@/shared/lib/cn';
import { APP_TITLE } from '@/shared/lib/seo/meta';
interface ComboboxPaymentProps {
  teachersList: Array<Teacher>;
  onOptionPick: (value: Teacher) => void;
}
export const ComboboxTeachers = (props: ComboboxPaymentProps) => {
  const {
    teachersList
  } = props;
  const {
    onOptionPick
  } = props;
  const onSelect = (teacher: Teacher) => {
    setValue(`${teacher.name} ${teacher.surname}`);
    onOptionPick(teacher);
    setOpen(false);
  };
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');
  return <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild className="focus-visible:ring-brand-accent-dark dark:focus-visible:ring-brand-accent-normal">
        <Button variant="outline" size="lg" role="combobox" aria-expanded={open} className="min-w-[50%] justify-between px-4">
          <p className="flex w-full items-center justify-between text-base sm:text-sm">
            {value && <span>{value}</span>}
            {!value && <span className="font-normal text-muted-foreground">Выберите учителя...</span>}

            <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </p>
        </Button>
      </PopoverTrigger>

      <PopoverContent className="p-0 xss:min-w-[350px] xs:min-w-[400px] sm:min-w-[300px] md:min-w-[350px] lg:min-w-[500px]" side="bottom" align="center" avoidCollisions={false}>
        <Command>
          <CommandInput placeholder="Введите имя..." className="text-base sm:text-sm" />

          <CommandEmpty>Учителей не найдено</CommandEmpty>

          <CommandGroup>
            <CommandList>
              {teachersList.map(teacher => <CommandItem key={teacher.id} value={`${teacher.name} ${teacher.surname}`} onSelect={() => onSelect(teacher)} className="mb-2">
                  <CheckMarkIcon className={cn('mr-3 h-5 w-5 shrink-0 rounded-full bg-brand-accent-light p-[2px] text-white dark:bg-brand-accent-normal', value === `${teacher.name} ${teacher.surname}` ? 'opacity-100' : 'opacity-0')} />

                  <Image width={50} height={50} src={teacher.img} alt={`${teacher.name} ${teacher.surname} - учитель в ${APP_TITLE}`} className="mr-4 h-12 w-12 rounded-full object-cover" />

                  <span className="text-sm">{`${teacher.name} ${teacher.surname}`}</span>
                </CommandItem>)}
            </CommandList>
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>;
};